import { ethers } from "ethers";
import { BigNumber } from "bignumber.js";

export const ethersToBN = (ethersBN: ethers.BigNumber): BigNumber =>
  new BigNumber(ethersBN.toString());
